/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createResourceCategoriesRepository = (options: RestApiOptions): Types.ResourceCategoriesRepository => ({
    async getAll(params, requestOptions) {
        return options.request('/resourceCategories/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
